module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-input illustration"
  }, [_c('div', {
    staticClass: "canvas"
  }, [_c('div', {
    staticClass: "base-gap",
    style: ({
      'height': ((_vm.getBaseGapHeight()) + "px")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "layer block-names"
  }, [_c('div', {
    staticClass: "top-name"
  }, [_vm._v("\n                Part\n            ")]), _vm._v(" "), (_vm.buildPlate) ? _c('div', {
    staticClass: "bottom-name"
  }, [_vm._v("\n                Build plate\n            ")]) : _c('div', {
    staticClass: "bottom-name"
  }, [_vm._v("\n                Part\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "layer legends"
  }, [_c('div', {
    staticClass: "fill top"
  }, [_c('div', {
    staticClass: "legend depth",
    style: ({
      'height': ((_vm.getLegendHeight('top-depth')) + "px"),
      'display': _vm.isDepthVisible('top')
    })
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "legend ot",
    style: ({
      'height': ((_vm.getLegendHeight('top-rect')) + "px")
    })
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "legend trapecia last",
    style: ({
      'height': ((_vm.getLegendHeight('top-trape')) + "px")
    })
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "placeholder-legends-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend trapecia",
    style: ({
      'height': ((_vm.getLegendHeight('bot-trape')) + "px"),
      'opacity': _vm.getOpacity()
    })
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "legend ot",
    style: ({
      'height': ((_vm.getLegendHeight('bot-rect')) + "px"),
      'opacity': _vm.getOpacity()
    })
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fill"
  }, [_c('div', {
    staticClass: "legend depth last",
    style: ({
      'height': ((_vm.getLegendHeight('bot-depth')) + "px"),
      'display': _vm.isDepthVisible('bot'),
      'opacity': _vm.getOpacity()
    })
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "layer support"
  }, [_c('div', {
    staticClass: "fill top"
  }, [_c('div', {
    staticClass: "rect depth",
    style: ({
      'height': ((_vm.getTopDepthHeight()) + "px"),
      'display': _vm.isDepthVisible('top'),
      'width': ((_vm.getWidth('top')) + "px")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "rect",
    style: ({
      'height': ((_vm.getTopRectHeight()) + "px"),
      'width': ((_vm.getWidth('top')) + "px")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rect upper trapecia",
    style: ({
      'border-bottom-width': ((_vm.getTopTrapeHeight()) + "px"),
      'border-left-width': _vm.getTrapeSkew('top'),
      'border-right-width': _vm.getTrapeSkew('top'),
      'width': ((_vm.getWidth('top')) + "px")
    })
  }, [_c('div', {
    staticClass: "legend-line"
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "rect main",
    class: {
      'build-plate': _vm.buildPlate
    }
  }), _vm._v(" "), (!_vm.buildPlate) ? _c('div', {
    staticClass: "rect bottom trapecia",
    style: ({
      'border-top-width': ((_vm.getBotTrapeHeight()) + "px"),
      'border-left-width': _vm.getTrapeSkew('bot'),
      'border-right-width': _vm.getTrapeSkew('bot'),
      'width': ((_vm.getWidth('bot')) + "px")
    })
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]) : _vm._e(), _vm._v(" "), (!_vm.buildPlate) ? _c('div', {
    staticClass: "rect",
    style: ({
      'height': ((_vm.getBotRectHeight()) + "px"),
      'width': ((_vm.getWidth('bot')) + "px")
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fill bottom"
  }, [_c('div', {
    staticClass: "rect depth",
    style: ({
      'height': ((_vm.getBotDepthHeight()) + "px"),
      'display': _vm.isDepthVisible('bot'),
      'width': ((_vm.getWidth('bot')) + "px"),
      'opacity': _vm.getOpacity()
    })
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("P"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("O"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("T"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("T"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("O"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("P"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("W"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("W"), _c('sub', [_vm._v("b")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3907c46c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3907c46c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateForm/SupportCanvas.vue
// module id = 479
// module chunks = 1